<template>
	<!-- 现场进度模块 -->
	<div class="mod-config">
		<el-card body-style="padding-bottom: 0;" style="margin-top: -5px;">
			<div class="title"> 现场进度 </div>
			<div class="line"></div>
			<el-row style="margin-bottom: 5px;">
				<el-col :span="pageSpan" v-if="showAdd">
					<el-button v-preventReClick class="btn" type="primary" size="small"
						@click="addOrUpdateHandle()">添加</el-button>
					<el-button v-preventReClick class="btn" type="primary" size="small" v-if="showFileKindSet"
						@click="sceneSettingHandle()">分类类型设定</el-button>
					<el-button v-preventReClick class="btn" type="primary" size="small" v-if="showFileKindSet"
						@click="progressPartsSettingHandle()">部件设定</el-button>
					<el-button v-preventReClick class="btn" type="primary" size="small" v-if="showFileKindSet"
						@click="progressPercentageSettingHandle()">百分比设定</el-button>
				</el-col>
			</el-row>
			<div class="line"></div>
			<el-form ref="form" :model="form" inline label-width="80px" label-position="left">
				<el-row
					style="background-color: rgb(243, 247, 247);margin-top: -10px;margin-left: -20px;height: 45px;width: 103%;">
					<el-col :span="19" style="margin-left:20px">
						<el-form-item label="进度分类" class="selFormItem">
							<el-select class="selSearchInput" v-model="sceneTypeId" placeholder="请选择" clearable>
								<el-option v-for="item in subjectList" :key="item.displayValue" :label="item.displayName"
									:value="item.displayValue">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4" class="selBtnGroup" style="margin-top:5px">
						<el-button v-preventReClick class="btn" type="primary" size="small" @click="selGetDataList()"
							v-if="showSearch">查询</el-button>
						<el-button v-preventReClick class="rebtn" size="small" @click="resetFormData()">重置</el-button>
					</el-col>
				</el-row>
			</el-form>
		</el-card>
		<div>
			<el-card style="margin-top: -25px; height: 530px;" body-style="height:490px; padding: 0;">
				<el-row style="height: 100%; margin-bottom: 10px;">
					<el-col :span="24" style="height: 100%;">
						<div class="box">
							<el-table height="470" :row-class-name="tableRowClassName" class="dataListTable" border
								:data="dataList" header-align="center" style="width: 100%; margin-bottom: 20px;"
								header-cell-class-name="stepPointTHeader" :cell-style="{ padding: '0px' }">
								<el-table-column label="NO." width="80" type="index" align="center">
								</el-table-column>
								<el-table-column prop="sceneTypeName" label="进度分类" width="120" align="left"
									header-align="center" show-overflow-tooltip>
								</el-table-column>
								<el-table-column prop="partsName" label="部件" width="120" header-align="center" align="left">
								</el-table-column>
								<el-table-column label="机号" width="120" align="left" header-align="center">
									<template slot-scope="scope">
										<span>{{ getSubjectName(scope.row.subjectNo) }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="progressDescribe" label="进度情况" align="left" show-overflow-tooltip
									header-align="center">
								</el-table-column>
								<el-table-column prop="proPerValue" label="进度百分率(%)" width="200" align="center"
									header-align="center">
								</el-table-column>
								<el-table-column prop="remark" label="备注" width="200" align="left" header-align="center"
									show-overflow-tooltip>
								</el-table-column>
								<el-table-column label="操作" width="250" align="center" v-if="showEdit || showDelete">
									<template slot-scope="scope">
										<el-button v-preventReClick type="text" size="small"
											@click="addOrUpdateHandle(scope.row.recNo)" v-if="showEdit">修改</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="deleteHandle(scope.row.recNo)" v-if="showDelete">删除</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
							@current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]"
							:page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
						</el-pagination>
					</el-col>
				</el-row>
			</el-card>
		</div>
		<!-- 弹窗, 新增节点 -->
		<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		<scene-setting v-if="sceneSettingVisible" ref="sceneSetting" @refreshDataList="getSubjectType()"></scene-setting>
		<progress-parts-setting v-if="progressPartsSettingVisible" ref="progressPartsSetting"></progress-parts-setting>
		<progress-percentage-setting v-if="progressPercentageSettingVisible"
			ref="progressPercentageSetting"></progress-percentage-setting>
	</div>
</template>

<script>
import AddOrUpdate from './progressSceneRecord-add-or-update'
import $common from "@/utils/common.js"
import SceneSetting from './scene-setting'
import ProgressPartsSetting from './progressParts-setting'
import ProgressPercentageSetting from './progressPercentage-setting'
export default {
	data() {
		return {
			showFileKindSet: false,
			showSearch: false,
			showAdd: false,
			showEdit: false,
			showDelete: false,
			sceneSettingVisible: false,
			progressPartsSettingVisible: false,
			progressPercentageSettingVisible: false,
			pageSpan: 12,
			form: {},
			addOrUpdateVisible: false,
			lookVisible: false,
			workNo: $common.getItem("workNo"),
			subjectNo: $common.getItem("subjectNo"),
			major: "",
			subjectList: [],
			sceneTypeId: "",
			dataList: [],
			meetTime: [],
			//当前页码
			pageIndex: 1,
			//当前记录数
			pageSize: 20,
			//总页数
			totalPage: 0,
		};
	},
	components: {
		AddOrUpdate,
		SceneSetting,
		ProgressPartsSetting,
		ProgressPercentageSetting
	},
	mounted() {
		this.showSearch = $common.isAuth('meeting:search');
		this.showAdd = $common.isAuth('meeting:add');
		this.showEdit = $common.isAuth('meeting:edit');
		this.showDelete = $common.isAuth('meeting:delete');
		this.showFileKindSet = $common.isAuth('examination:file:kind:set');
		if (!this.showAdd) {
			this.pageSpan = 24;
		}
		this.getDataList();
		this.getSubjectType();
	},
	methods: {
		getSubjectName(id) {
			let rtn = ''
			this.$store.state.common.navBarSubjectList.forEach(function (item, idx) {
				if (id === item.displayValue) {
					rtn = item.displayName
				}
			})
			return rtn;
		},
		//自适应高度
		siteContentViewHeight() {
			var height = this.$store.state.common.documentClientHeight - 260;
			return {
				height: height + 'px'
			}
		},
		getRowClass(row, rowIndex) {
			if (!row.row.subList || row.row.subList.length === 0) {
				return 'row-expand-cover'
			}
			return ''
		},
		selGetDataList() {
			this.pageInde = 1;
			this.getDataList();
		},
		currentChangeHandle(val) {
			this.pageIndex = val
			this.getDataList()
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val;
			this.pageIndex = 1;
			this.getDataList();
		},
		sceneSettingHandle() {
			this.sceneSettingVisible = true
			this.$nextTick(() => {
				this.$refs.sceneSetting.init(2);
			})
		},
		progressPartsSettingHandle() {
			this.progressPartsSettingVisible = true
			this.$nextTick(() => {
				this.$refs.progressPartsSetting.init(2);
			})
		},
		progressPercentageSettingHandle() {
			this.progressPercentageSettingVisible = true
			this.$nextTick(() => {
				this.$refs.progressPercentageSetting.init(2);
			})
		},
		getDataList() {
			if (this.showSearch) {
				this.$http({
					url: this.$store.state.httpUrl + "/business/progressscenerecord/list",
					method: "get",
					params: {
						workNo: $common.getItem("workNo"),
						sceneTypeId: this.sceneTypeId,
						// subjectNo: this.subjectNo,
						limit: this.pageSize,
						page: this.pageIndex
					},
				}).then(({ data }) => {
					if (data && data.code === 200) {
						this.dataList = data.body.records;
						this.totalPage = data.body.totalCount;
					}
				});
			}
		},
		getSubjectType() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getSubjectInfo/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.subjectList = data.body;
				}
			});
		},
		//删除
		deleteHandle(id) {
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/progressscenerecord/delete/",
					method: 'post',
					data: this.$http.adornData([id], false)
				}).then(({
					data
				}) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					} else {
						this.$message.error(data.msg)
					}
				})
			});
		},
		// 新增节点
		addOrUpdateHandle(id) {
			this.addOrUpdateVisible = true
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init(id)
			})
		},
		resetFormData() {
			this.meetKind = "";
			this.meetTime = [];
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
	}
};
</script>
<style lang="scss" scoped>
.my-pagination {
	margin-right: 20px !important;
}

// 设置表头样式
::v-deep(.el-table th.el-table__cell) {
	// background-color: #d3e2f4 !important;
	font-size: 15px;
	padding: 2px 0;
}

::v-deep(.selSearchInput .el-input__inner) {
	width: 140px !important;
	height: 30px !important;
}

::v-deep(.selFormItem .el-form-item__label) {
	font-size: smaller;
}
</style>
